import { render, staticRenderFns } from "./SendBulkStudents.vue?vue&type=template&id=25a2c902&scoped=true"
import script from "./SendBulkStudents.vue?vue&type=script&lang=ts"
export * from "./SendBulkStudents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2c902",
  null
  
)

export default component.exports